import { Injectable, inject } from '@angular/core';

import { take } from 'rxjs';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { DslService } from '../dsl/dsl.service';
import { DatadogRumConfig } from './datadog-rum.client-config';
import { DatadogRumService } from './datadog-rum.service';

@Injectable()
export class DatadogRumBootstrapService implements OnAppInit {
    private readonly datadogRumService = inject(DatadogRumService);
    private readonly datadogRumConfig = inject(DatadogRumConfig);
    private readonly dslService = inject(DslService);

    onAppInit() {
        this.dslService
            .evaluateExpression<boolean>(this.datadogRumConfig.isEnabledCondition)
            .pipe(take(1))
            .subscribe((enabled) => {
                if (enabled) {
                    this.datadogRumService.init();
                }
            });
    }
}
